export default __webpack_public_path__ + "static/media/ic_seedata.acb3da51.svg";